import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const FooterStyle = withTheme(styled.div`
  padding: 30px 0px;
  background: ${(props: any) => props.theme.palette.primary.dark};
  color: white;
  display: flex;

  .join-us-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;

    .title1 {
      font-size: 36px;
      line-height: 1.2;
    }
    .title2 {
      font-size: 48px;
      font-weight: bold;
      line-height: 1.2;
    }
    .detail {
      font-size: 24px;
      margin-bottom: 50px;
      text-align: center;
    }

    .join-us-button {
      width: 153px;
      height: 32px;
      border-radius: 28px;
      border: solid 1px white;
      background-color: white;
      font-size: 24px;
      line-height: 1.21;
      color: ${(props: any) => props.theme.palette.primary.dark};
    }

    .hubsport-contact-form {
      flex: 1;
      width: 80%;
      background-color: white;
      justify-content: center;
      padding: 40px 40px;
    }
  }

  .remark {
    font-size: 16px;
    text-align: right;
  }

  .MuiDivider-root {
    margin: 5px 0 50px 0;
    border: solid 1px white;
  }

  .footer-container {
    display: flex;

    justify-content: space-between;
    align-items: flex-end;

    .contact-us-container {
      a {
        color: white;
      }

      .contact-box {
        display: flex;
        align-items: center;
        font-size: 15px;

        .email {
          text-decoration: underline;
          font-size: 15px;
        }

        svg {
          font-size: 18px;
          margin-right: 10px;
        }

        .arrow {
          margin-left: auto;
        }
      }
    }
  }

  .logo-container {
    img {
      width: 150px;
    }
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .join-us-container {
      margin-bottom: 30px;

      .title1 {
        font-size: 24px;
      }
      .title2 {
        font-size: 36px;
        font-weight: bold;
      }
      .detail {
        font-size: 18px;
        margin-bottom: 30px;
      }
    }
    .remark {
      text-align: center;
      margin-bottom: 25px;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .join-us-container {
      margin-bottom: 40px;

      .title1 {
        font-size: 18px;
      }
      .title2 {
        font-size: 36px;
        font-weight: bold;
      }
      .detail {
        font-size: 18px;
        margin-bottom: 30px;
      }
    }

    .remark {
      text-align: center;
      margin-bottom: 25px;
    }

    .MuiDivider-root {
      margin-bottom: 40px;
    }

    .footer-container {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      .logo-container {
        margin-bottom: 40px;
      }
    }
  }
`);

export default FooterStyle;
